
import React , { useState , useContext } from "react";
import { Link , NavLink, Outlet , useNavigate } from "react-router-dom";
import  { WebAssetsContext }  from "../../App";
const  PaginationCustom = (props) => {


  console.log(props);


  const renderPageNumbers = () => {
    let content = [];
    
    for (let i = 1; i <= props.totalPages; i++) {
      
      content.push(<li className={`page-item ${(props.currentpage == i ) &&  'active' }`} 
      
      onClick={()=> props.updateCurrentPage(i)}><Link className={`page-link`}  >{i}</Link></li>);
    }
    return content;
    
  };

  return (
      <> 
         
        {props.totalPages > 0 && 
          <nav aria-label="Page navigation example">
            <ul className="pagination">
              {props.currentpage > 1 &&
              <li className="page-item">
                  <Link className="page-link"  onClick={()=> props.updateCurrentPage(props.currentpage-1) } >Previous</Link>
              </li>
              }
                {renderPageNumbers()}
                {props.currentpage < props.totalPages   &&
              <li className="page-item">
                <Link className="page-link" onClick={()=> props.updateCurrentPage(props.currentpage+1) } >Next</Link>
              </li>
              }
            </ul>
          </nav>
          }
      </>
    );
}

export default PaginationCustom;
